export const ImplantPriceData = [
    {
        id: 1,
        service: 'Удаление зуба',
        price: '3500 - 7000',
    },
    {
        id: 2,
        service: 'Внутрикостная дентальная имплантация',
        price: '30000 - 45000',
    },
    {
        id: 3,
        service: 'Установка формирователя десны',
        price: '3000',
    },
    {
        id: 4,
        service: 'Синус-лифтинг',
        price: '10000 - 60000',
    },
    {
        id: 5,
        service: 'Пластика десны аутотрансплантатом в области одного сегмента',
        price: '5000',
    },
    {
        id: 6,
        service: 'Вестибулопластика',
        price: '10000',
    },
]